/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {ChangeDetectionStrategy, Component, inject, OnDestroy} from '@angular/core';
import {RedirectService, SignInComponent} from 'compob2b-auth';
import {take} from 'rxjs/operators';

@Component({
  selector: 'app-sign-in',
  templateUrl: './admin-sign-in.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `
    .logo { padding: 20vh 0 20px; text-align: center; overflow: hidden }

    img {
      height: 40px;
      animation-delay: .5s;
      animation-duration: .4s;
      animation-name: slidein;
      animation-fill-mode: forwards;
      transform: translate(0, -400px);
    }

    @keyframes slidein {
      from {
        opacity: 0;
        transform: translate(0, -400px);
      }
      to {
        opacity: 1;
        transform: translate(0, 0);
      }
    }

    .stitle { text-align: center; margin: 0 0 20px 0 }
  `,
})
export class AdminSignInComponent extends SignInComponent implements OnDestroy {
  redirect = inject(RedirectService);
  uri = this.redirect.getUri();

  /**
   * Override method
   */
  afterSignIn(): void {
    this.redirect.getUri().pipe(take(1))
      .subscribe(uri => {
        if (uri !== null && uri !== undefined && uri.length > 0) {
          this.router.navigateByUrl(uri);
          this.redirect.next(null);
        } else {
          this.router.navigate(['cabinet']);
        }
      });
  }

}
